import { TableCell as MuiTableCell, TableCellProps as MuiTableCellProps, useTheme } from "@mui/material";
import { Stack } from "./Stack";

type TableCellProps = MuiTableCellProps & {
  type?: "select" | "action" | "id" | undefined;
};

export const TableCell = ({ children, type, ...rest }: TableCellProps) => {
  const theme = useTheme();
  let typeAttributes: any;

  if (type === "select") typeAttributes = { align: "center", width: "1%", onClick: (e: any) => e.stopPropagation() };
  if (type === "action") typeAttributes = { align: "left", width: "1%", onClick: (e: any) => e.stopPropagation() };
  if (type === "id") typeAttributes = { align: "center", width: "80px" };

  return (
    <MuiTableCell {...typeAttributes} {...rest} sx={{
        "&.MuiTableCell-root": {
          color: `${theme.palette.text.primary} !important`,
        },
        ...(rest.sx || {})
      }}>
      {type === "action" ? (
        <Stack direction="row" alignItems="center" justifyContent={"flex-end"}>
          {children}
        </Stack>
      ) : (
        children
      )}
    </MuiTableCell>
  );
};
